import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class I18nInterceptor implements HttpInterceptor {

  constructor() {
  }

  /**
   * Intercepts translations files requests and sets a no-cache header thus preventing translation
   * files from being cached and possibly outdated
   * @param request
   * @param next
   */
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!request.url.includes('assets/i18n')) {
      return next.handle(request);
    }

    const modifiedReq = request.clone({
      headers: request.headers.set('Cache-Control', 'no-cache'),
    });
    return next.handle(modifiedReq);
  }
}
